import React, { useState, useEffect, useRef } from "react";
import { Typography, FormControl, TextField } from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import { updateProfile, hideError } from "../../redux/action";
import { allowedIdType } from "../../../utils/allowedIdType";
import { StepLabel, CustomButton, DefaultLoader } from "../../../components";
import styles from "../styles";
import {
  getAddress,
  setGetAddressLoading,
  resetAddress,
} from "../../onBoarding/redux/action";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";
import { POS_00001 } from "../../../utils/errorCodes";

const UpdatePostCode = props => {
  const {
    loading,
    profile,
    updateProfile,
    address,
    getAddressLoading,
    getAddress,
    setGetAddressLoading,
    resetAddress,
    stateList,
    history,
  } = props;

  const currentAddress = profile?.contacts?.find(
    contact => contact.contactTypeCd === "PERMANENT"
  );

  const [userInfo, setUserInfo] = useState(null);
  const [value, setValue] = useState(() => {
    const state = stateList.find(
      stateItem => stateItem.code === currentAddress.state
    );

    if (!currentAddress || !state)
      return {
        city: "",
        postCode: "",
        state: {
          code: "",
          name: "",
        },
      };

    return {
      postCode: currentAddress.postCode,
      state: {
        code: state?.code,
        name: state?.name,
      },
      city: currentAddress.city,
    };
  });
  const [postCodeError, setPostCodeError] = useState(false);

  const [isTax, setIsTax] = useState(false);
  const isDirty = useRef(false);

  const initialGetAddressLoading = !isDirty.current && getAddressLoading;
  const subsequentGetAddressLoading = isDirty.current && getAddressLoading;

  const localIdentity = profile?.identities?.find(allowedIdType);

  useEffect(() => {
    // reset
    setGetAddressLoading(false);

    return () => {
      resetAddress();
    };
  }, []);

  useEffect(() => {
    if (profile) {
      setUserInfo(profile);
    }
  }, [profile]);

  useEffect(() => {
    if (userInfo) {
      setIsTax(
        userInfo.identities &&
          userInfo.identities.find(identity => identity.idTypeCd === "TAX")
          ? true
          : false
      );
    }
  }, [profile]);

  useEffect(() => {
    if (value?.postCode?.length === 5) {
      setGetAddressLoading(true);
      setPostCodeError(false);
      getAddress(value.postCode, err => {
        if (err?.errorCode === POS_00001) {
          setPostCodeError(true);
        } else {
          setPostCodeError(false);
        }
      });
    } else {
      setPostCodeError(true);
    }
  }, [value.postCode]);

  useEffect(() => {
    if (Object.values(address).length > 0) {
      const state = stateList.find(
        stateItem => stateItem.code === address.state
      );

      setValue(prev => ({
        ...prev,
        postCode: address.postalCode,
        city: address.city,
        state: {
          code: state?.code,
          name: state?.name,
        },
      }));
    }
  }, [address]);

  const handleUpdate = () => {
    // window.consoleLog(city);
    if (
      (value.postCode.length > 0 && postCodeError) ||
      getAddressLoading ||
      currentAddress?.postCode === value.postCode
    ) {
      return;
    }

    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        postCode: value.postCode, //R the updated
        city: value.city, //R
        state: value.state.code, //R,
        country: localIdentity?.citizenship, //R
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    // window.consoleLog(payload);
    updateProfile({ payloadData: payload, from: PROFILE });
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {(loading || initialGetAddressLoading) && <DefaultLoader />}
      <StepLabel
        title="Update postal code"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <Typography
            color="textPrimary"
            style={{ ...styles.baseFont, ...styles.inputLabel }}
          >
            Postal code
          </Typography>
          <TextField
            placeholder="Postal code"
            variant="outlined"
            fullWidth
            value={value?.postCode}
            onChange={e => {
              if (!isDirty.current) {
                isDirty.current = true;
              }

              const code = e.target.value;
              const reg = new RegExp(/^(\d+)?$/);
              if (reg.test(code)) {
                setValue(prev => ({
                  ...prev,
                  postCode: code,
                }));
              }
            }}
            error={postCodeError}
            helperText={
              postCodeError &&
              (value?.postCode
                ? "Please enter a valid postal code"
                : "This field is required")
            }
            FormHelperTextProps={{
              className: "c-input__text",
            }}
            inputProps={{
              className: "c-input c-input--outline",
              style: {
                padding: "12px 16px",
              },
              maxLength: 5,
            }}
            InputProps={{
              style: {
                padding: "2px 16px",
              },
            }}
          />
          <Typography
            color="textPrimary"
            className={`${styles.baseFont} ${styles.label}`}
            style={{
              marginTop: "8px",
            }}
          >
            City *
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={
              subsequentGetAddressLoading || postCodeError
                ? ""
                : value.city?.replace(
                    /\b[A-Z]+\b/g,
                    match => match.charAt(0) + match.slice(1).toLowerCase()
                  )
            }
            FormHelperTextProps={{
              className: "c-input__text",
            }}
            inputProps={{
              className: "c-input c-input--outline",
              style: {
                padding: "12px 16px",
                width: `${subsequentGetAddressLoading ? "40%" : "100%"}`,
              },
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              className: "c-input__wrapper--disabled",
              readOnly: true,
              disabled: true,

              startAdornment: subsequentGetAddressLoading ? (
                <>
                  <div className="loader" />
                  <span style={{ display: "inline-block", marginLeft: "5px" }}>
                    Retrieving city
                  </span>
                </>
              ) : null,
            }}
          />
          <Typography
            color="textPrimary"
            className={`${styles.baseFont} ${styles.label}`}
          >
            State *
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={
              subsequentGetAddressLoading || postCodeError
                ? ""
                : value.state.name
            }
            FormHelperTextProps={{
              className: "c-input__text",
            }}
            inputProps={{
              className: "c-input c-input--outline",
              style: {
                padding: "12px 16px",
                width: `${subsequentGetAddressLoading ? "40%" : "100%"}`,
              },
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              className: "c-input__wrapper--disabled",
              readOnly: true,
              disabled: true,

              startAdornment: subsequentGetAddressLoading ? (
                <>
                  <div className="loader" />
                  <span style={{ display: "inline-block", marginLeft: "5px" }}>
                    Retrieving state
                  </span>
                </>
              ) : null,
            }}
          />
        </FormControl>
      </form>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={postCodeError || getAddressLoading}
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
    address: state.onBoardingReducer.address,
    getAddressLoading: state.onBoardingReducer.getAddressLoading,
    stateList: state.goal.stateList,
  }),
  {
    updateProfile,
    hideError,
    getAddress,
    setGetAddressLoading,
    resetAddress,
  }
);
export default compose(
  withRouter,
  withConnect
)(UpdatePostCode);
